webpackJsonp([35783957827783],{

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(41);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ArticleModule = __webpack_require__(356);
	
	var _ArticleModule2 = _interopRequireDefault(_ArticleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Article = function Article(_ref) {
	  var title = _ref.title,
	      date = _ref.date,
	      excerpt = _ref.excerpt,
	      slug = _ref.slug;
	
	  var firstChar = title.charAt(0);
	
	  return _react2.default.createElement(
	    'article',
	    { className: _ArticleModule2.default.post },
	    _react2.default.createElement(
	      'h2',
	      { className: _ArticleModule2.default.title },
	      _react2.default.createElement(
	        'span',
	        { className: _ArticleModule2.default.initiale },
	        firstChar
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: slug },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'h4',
	      { className: _ArticleModule2.default.date },
	      date
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _ArticleModule2.default.excerpt },
	      excerpt
	    )
	  );
	};
	
	exports.default = Article;
	module.exports = exports['default'];

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"post":"src-components----Article-module---post---11pmO","initiale":"src-components----Article-module---initiale---2LDiJ","title":"src-components----Article-module---title---1ZJTI","date":"src-components----Article-module---date---2EdNx","excerpt":"src-components----Article-module---excerpt---3_eZr"};

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(41);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _MenuModule = __webpack_require__(125);
	
	var _MenuModule2 = _interopRequireDefault(_MenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Menu.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _MenuModule2.default.menu },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Home'
	      ),
	      '|',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/our-adventures' },
	        'Our adventures'
	      ),
	      '|',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/weird-about-us' },
	        'WeirdAboutUS'
	      ),
	      '|',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/my-work' },
	        'My work'
	      )
	    );
	  };
	
	  return Menu;
	}(_react2.default.Component);
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"src-components----Menu-module---menu---2fE1l"};

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IndexQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Article = __webpack_require__(262);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Menu = __webpack_require__(95);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _indexModule = __webpack_require__(359);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  var postEdges = props.data.allMarkdownRemark ? props.data.allMarkdownRemark.edges : [];
	
	  return _react2.default.createElement(
	    'div',
	    { className: _indexModule2.default.indexContent },
	    _react2.default.createElement(_Menu2.default, { className: _indexModule2.default.menu }),
	    _react2.default.createElement(
	      'div',
	      { className: _indexModule2.default.hero },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Yet another blog..'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'On developing awesome code, living in the U.S. and traveling!'
	      )
	    ),
	    postEdges.map(function (post) {
	      if (!post.node.frontmatter.date) {
	        // Skip posts without a date
	        return false;
	      }
	      return _react2.default.createElement(_Article2.default, {
	        title: post.node.frontmatter.title,
	        date: post.node.frontmatter.date,
	        excerpt: post.node.excerpt,
	        slug: post.node.fields.slug,
	        key: post.node.fields.slug
	      });
	    })
	  );
	};
	
	exports.default = IndexPage;
	
	/* eslint no-undef: off */
	
	var IndexQuery = exports.IndexQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"src-pages----index-module---menu---2wZFh","indexContent":"src-pages----index-module---indexContent---1Ll7Q","hero":"src-pages----index-module---hero---2Osae"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-30e28fcb2f6b7e74660c.js